<template>
  <div class="plv-iar-c-countdown" :class="{'plv-iar-c-countdown--small': size === 'small'}">
    <div class="plv-iar-c-countdown__block plv-font-din-pro-regular">{{ hours }}</div>
    <div class="plv-iar-c-countdown__separator">:</div>
    <div class="plv-iar-c-countdown__block plv-font-din-pro-regular">{{ minutes }}</div>
    <div class="plv-iar-c-countdown__separator">:</div>
    <div class="plv-iar-c-countdown__block plv-font-din-pro-regular">{{ seconds }}</div>
  </div>
</template>

<script>
export default {
  props: {
    /** 倒计时时间（秒） */
    duration: {
      type: Number,
      default: 0
    },
    /** 尺寸 */
    size: {
      type: String,
      default: ''
    }
  },

  computed: {
    // 计算小时数
    hours() {
      return String(Math.floor(this.duration / 3600)).padStart(2, '0');
    },

    // 计算分钟数
    minutes() {
      return String(Math.floor((this.duration % 3600) / 60)).padStart(2, '0');
    },

    // 计算秒数
    seconds() {
      return String(this.duration % 60).padStart(2, '0');
    }
  }
};
</script>

<style lang="scss">
@import '../../../assets/styles/basic.scss';

.plv-iar-c-countdown {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;

  &__block {
    width: 68px;
    height: 78px;
    background: #E5F2FE;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    user-select: none;
    font-size: 48px;
    font-weight: bold;
    color: #3082FE;
  }

  &__separator {
    font-weight: bold;
    user-select: none;
    font-size: 48px;
    color: #3F76FC;
  }
}

.plv-iar-c-countdown--small {
  gap: 4px;
  .plv-iar-c-countdown__block {
    width: 24px;
    height: 26px;
    border-radius: 2px;
    background: rgba(255, 166, 17, 0.2);
    font-size: 16px;
    color: #FFA611;
  }

  .plv-iar-c-countdown__separator {
    font-size: 16px;
    color: #FFA611;
  }
}
</style>
